// var locator = require('./storelocator');
import {initializePDPEvents, resetStoreSearch, initPDPStoreData} from './storelocator';

var tooltip = require('../tooltip');
var $main = $('#main'); 
var userPastOverlayScrollPos = [0,0];
function onStoreAvailabilityGAEvent() {
    var product = dataLayer.find(o => o.product != null).product;
    var user = dataLayer.find(o => o.user != null).user;
	dataLayer.push({
	    'event': 'custom_event',
	    'eventCategory': 'PDP',
	    'eventAction': 'check_in_store_availability',
	    'eventLabel': 'check in store availability click',
	    'productName': product ? product.name : '',  // Name of product page
	    'country': window.GlobalAttributes.COUNTRY,
	    'language': window.GlobalAttributes.LANGUAGE,
	    'screenName' : 'PDP',
	    'userType':  user.user_id!='' ? 'logged-in' : 'logged-out',
	    'userId': user.user_id!=''? user.user_id : '' 
	});
}

function initializeStoreEvents(){
    //Open Checkinstore  Modal
    $(document).on("click",".chkstore--head",function(){
    	onStoreAvailabilityGAEvent();
        $(".chkstore_container").addClass('toggle--active').find('.in').removeClass('in');
        scrollLock(true);
        if(typeof zE !== 'undefined' && !!zE) {
            zE(function() {
               zE.hide();
            });
        }
        resetStoreSearch();
        if (typeof pdpStoreStockCheckPushEvent !== "undefined") { 
            pdpStoreStockCheckPushEvent('store_availability_click');
        }
        $(".chkstore_size_container").removeClass('in');
        $(".chkstore_store_container").addClass('in');
        
        resetStoreSearch();
        initPDPStoreData();
        tooltip.init();
    });

    //Close Checkinstore Modal
    $(document).on("click",".chkstore_modal_close",function(){
        $(".chkstore_container").removeClass('toggle--active');
        $(".chkstore_size_container .swatch__link").removeClass('selected');
        $(".checksize--instore").attr("disabled","disabled");
        scrollLock(false);
        if(typeof zE !== 'undefined' && !!zE) {
            zE(function() {
               zE.show();
            });
        }
    });

    //Size Selection Highlights
    $(".chkstore_size_container .swatches__item-size a").off().on("click",function(e){
        e.stopPropagation();
        const target = $(this).parent('.swatch__link');
        target.toggleClass('selected');
        ($(".chkstore_size_container .swatch__link.selected").length > 0) ? $(".checksize--instore").removeAttr("disabled") : $(".checksize--instore").attr("disabled","disabled");
    });

    //Get Selected Size
    $(document).on('click',".checksize--instore",function(){
        let selectedSize = [];
        const targetEle = $(".chkstore_size_container .swatch__link.selected a.swatch__link--anchor");
        targetEle.each(function(){
            selectedSize.push($(this).attr('data-id'));
        });
        $(".chkstore_size_container").removeClass('in');
        $(".chkstore_store_container").addClass('in');
        var selected = selectedSize.join(" , ");
        $(".selectedInfo").text(selected).data('selected', selected);
        resetStoreSearch();
        if (typeof pdpStoreStockCheckPushEvent !== "undefined") { 
            pdpStoreStockCheckPushEvent('size_store_selection');
        }
        initPDPStoreData();
    });

    //Back to CheckSize UI
    $(document).on("click",".backtosizeinfo",function(){
        $(".chkstore_size_container").addClass('in');
        $(".chkstore_store_container").removeClass('in');
    });
    $(document).ready(function () {
        if($('.chkstore_wrapper').length > 0) {
            initializePDPEvents();
        }
    });
}
function scrollLock(state){
    if(state === true){
        userPastOverlayScrollPos = [
            self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
            self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
        ];
        $('html').addClass('cancel-scroll noscrollios');
        $('body').addClass('cancel-scroll');
    }else{
        $('html').removeClass('cancel-scroll noscrollios');
        $('body').removeClass('cancel-scroll');
        window.scrollTo(userPastOverlayScrollPos[0], userPastOverlayScrollPos[1]);
    }
}

exports.initstore = function () {
    initializeStoreEvents();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkinstore.js